/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { useInjectReducer } from "../utilize/injectReducer";
import { useInjectSaga } from "../utilize/injectSaga";
import reducer from "./reducer";
import saga from "./saga";
import history from "../utilize/history";
import { useDispatch } from "react-redux";
import { resetElection } from "screens/Election/actions";
import { resetSchool } from "screens/Anjoman/actions";

const Home = lazy(() => import("../screens/Home"));
const EnghelabSchool = lazy(() => import("../screens/EnghelabSchool"));
const Calender = lazy(() => import("../screens/Calender"));
const Login = lazy(() => import("../screens/Login"));
const SignUp = lazy(() => import("../screens/SignUp"));
const ForgetPassword = lazy(() => import("../screens/ForgetPassword"));
const Anjoman = lazy(() => import("../screens/Anjoman"));
const Activity = lazy(() => import("../screens/Activity"));
const Activities = lazy(() => import("../screens/Activities"));
const AddEditActivity = lazy(() =>
  import("../screens/Activity/components/AddEditActivity")
);
const Messaging = lazy(() => import("../screens/Messaging"));
const Election = lazy(() => import("../screens/Election"));
const League = lazy(() => import("../screens/League"));
const Profile = lazy(() => import("../screens/Profile"));
const NotFound = lazy(() => import("../screens/NotFound404"));
const Counter = lazy(() => import("../screens/Counter"));
const CounterDetail = lazy(() => import("../screens/CounterDetail"));
const ChangePassword = lazy(() => import("../screens/ChangePassword"));
const SearchPeopleResult = lazy(() => import("../screens/SearchPeopleResults"));
const SearchUnitResult = lazy(() => import("../screens/SearchUnitsResults"));
const IdeationMyIdeas = lazy(() => import("../screens/Ideation/MyIdeas"));
const IdeationConvocation = lazy(() =>
  import("../screens/Ideation/Convocation")
);
const AddEditIdeationConvocation = lazy(() =>
  import("../screens/Ideation/Convocation/AddOrUpdate")
);
const IdeationConvocationDetail = lazy(() =>
  import("../screens/Ideation/Convocation/Detail")
);
const IdeationIdeaDetail = lazy(() =>
  import("../screens/Ideation/Idea/Detail")
);
const AddEditIdeationIdea = lazy(() =>
  import("../screens/Ideation/Idea/AddOrUpdate")
);

export default function Index() {
  useInjectReducer({ key: "main", reducer });
  useInjectSaga({ key: "main", saga });
  const dispatch = useDispatch();
  const router = useLocation();
  const isAuth = localStorage.getItem("aghighToken");
  useEffect(() => {
    if (!isAuth) {
      dispatch(resetElection());
      dispatch(resetSchool());
    }
  }, [isAuth]);
  useEffect(() => {
    if (
      (!isAuth || isAuth === "undefined") &&
      router.pathname !== "/" &&
      router.pathname !== "/enghelab/school" &&
      router.pathname !== "/counter/50" &&
      router.pathname !== "/signup" &&
      router.pathname !== "/forgetpassword"
    ) {
      history.push({ pathname: "/login", state: { from: router.location } });
    }
  }, []);

  return (
    <Suspense fallback={<></>}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/enghelab/school" component={EnghelabSchool} />
        <Route exact path="/calender" component={Calender} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/signUp" component={SignUp} />
        <Route exact path="/change-password" component={ChangePassword} />
        <Route exact path="/forgetpassword" component={ForgetPassword} />
        <Route path="/activities" component={Activities} />
        <Route
          exact
          path="/search/user/:value"
          component={SearchPeopleResult}
        />
        <Route exact path="/search/unit/:value" component={SearchUnitResult} />
        <Route exact path="/activity/detail/:slug" component={Activity} />
        <Route exact path="/activity/share/:slug" component={Activity} />
        <Route exact path="/associations/:unit/:slug" component={Anjoman} />
        <Route exact path="/add-activity" component={AddEditActivity} />
        <Route exact path="/edit/:edit/:slug" component={AddEditActivity} />
        <Route path="/messaging" component={Messaging} />
        <Route exact path="/election/" component={Election} />
        <Route exact path="/league" component={League} />
        <Route exact path="/profile/:slug" component={Profile} />
        <Route exact path="/counter" component={Counter} />
        <Route exact path="/counter/:id" component={CounterDetail} />
        <Route exact path="/ideation/my-ideas" component={IdeationMyIdeas} />
        <Route
          exact
          path="/ideation/convocation"
          component={IdeationConvocation}
        />
        <Route
          exact
          path="/ideation/convocation/add"
          component={AddEditIdeationConvocation}
        />
        <Route
          exact
          path="/ideation/convocation/edit/:id"
          component={AddEditIdeationConvocation}
        />
        <Route
          exact
          path="/ideation/convocation/:id"
          component={IdeationConvocationDetail}
        />
        <Route exact path="/ideation/idea/:id" component={IdeationIdeaDetail} />
        <Route
          exact
          path="/ideation/idea/add/:convocationID"
          component={AddEditIdeationIdea}
        />
        <Route
          exact
          path="/ideation/idea/edit/:convocationID/:id"
          component={AddEditIdeationIdea}
        />

        <Route exact path="/not-found" component={NotFound} />
      </Switch>
    </Suspense>
  );
}
